// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useState} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';
import styles from './survey.module.less';

interface i_survey_rating_props extends i_survey_rating {
    save: t_survey_save;
}
export const Survey_rating = (props: i_survey_rating_props)=>{
    const {theme} = useContext(Settings_context);
    const {id, save, max = 5, text} = props;
    const [current, set_current] = useState(0);
    const on_rate = (v:number)=>{
        set_current(v);
        save(id, [v]);
    };
    const cls = cn(styles.survey_rating, styles.survey_choice);
    return <div className={cls}>
      <p className={theme.p2}>{text}</p>
      <div className={styles.buttons}>
        {new Array(+max).fill(0).map((_v, index)=>{
          const btn_cls = cn(theme.p2, {[styles.highlight]: index < current});
          return <button key={index} className={btn_cls}
            onClick={()=>on_rate(index+1)}>{index + 1}</button>;
        })}
      </div>
    </div>;
};
